import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconHourglass } from '@sorare/core/src/atoms/icons/system/iconHourglass.ts';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft';

const Root = styled(Vertical).attrs({ center: true })`
  width: 100%;
  padding: var(--triple-unit);
  border-radius: var(--unit);
  border: 1px solid var(--c-nd-150);
  svg {
    margin-right: var(--unit);
  }
`;

export const EmptyState = ({ startDatetime }: { startDatetime: Date }) => {
  return (
    <Root>
      <LabelL bold color="var(--c-nd-600)">
        <FontAwesomeIcon icon={iconHourglass} size="lg" />
        <FormattedMessage
          defaultMessage="Power Grade updates 48 hours before next Game Week.{br}They will be available in {timeLeft}"
          values={{ timeLeft: <TimeLeft time={startDatetime} />, br: <br /> }}
        />
      </LabelL>
    </Root>
  );
};
